import { Typography, Box } from "@mui/material"
import { NumberField, useTranslate } from "react-admin"
import { TotalInvoiceAmounts } from "../GeneratedClients/FreeBillApi"

const InvoicesFacts = ({data}: {data?: TotalInvoiceAmounts}) => {

  const translate = useTranslate()

  if(!data) return null

  return (
    <Box my={3} mx={3} minWidth={150} display={{sm: "none", md: "block"}} >
      <Box my={2}>
        <Typography m={0} gutterBottom sx={{ color: 'text.secondary', fontSize: 11 }}>{translate("resources.dashboard.invoices.facts.count")}</Typography>
        <NumberField fontSize={18} record={data} source="totalInvoices"  />
      </Box>
      <Box my={2}>
        <Typography m={0} gutterBottom sx={{ color: 'text.secondary', fontSize: 11 }}>{translate("resources.dashboard.invoices.facts.netSum")}</Typography>
        <NumberField fontSize={18} record={data} source="totalNetAmount"  options={{ style: 'currency', currency: 'EUR' }} />
      </Box>    
      <Box my={2}>
        <Typography m={0} gutterBottom sx={{ color: 'text.secondary', fontSize: 11 }}>{translate("resources.dashboard.invoices.facts.taxSum")}</Typography>
        <NumberField fontSize={18} record={data} source="totalTaxAmount"  options={{ style: 'currency', currency: 'EUR' }} />
      </Box> 
      <Box my={2}>
        <Typography m={0} gutterBottom sx={{ color: 'text.secondary', fontSize: 11 }}>{translate("resources.dashboard.invoices.facts.grossSum")}</Typography>
        <NumberField fontSize={18} record={data} source="totalGrossAmount"  options={{ style: 'currency', currency: 'EUR' }} />
      </Box>   
    </Box>
  )
}

export default InvoicesFacts